import { SortType } from '@/enums/sort-type.enum';
import { SortState } from '@/interfaces/states/sort-state.interface';
import { SortActions } from './actions.enum';

export default {
  [SortActions.SET_TYPE](state: SortState, type: SortType): void {
    state.type = type;
  },
};
